exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer-question{font-size:12px}.corCinzaClaro{background-color:#efefef;border:1px solid #ddd}.validationTitle{margin-bottom:10%}.validationBlock{display:flex;flex:1;flex-direction:row;margin:auto;font-size:12px}.validateType{margin-left:2%}.circleNoValidate{color:red;font-size:16px}.circleValidate{color:green;font-size:16px}.passwordFieldBlock{display:flex;flex-direction:row;align-content:space-between}.link{color:#0277bd;font-weight:700;text-align:right;margin:5px}.link,.texto-passo{text-transform:uppercase}.texto-passo{color:#a9a4a4;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/components/views/password/password.style.scss
// module id = 792
// module chunks = 0